
export default {
    props: {
        data: {
            required: true,
            type: Number,
        },
    },
    data() {
        return {
            counter: 0 as number | undefined,
        };
    },
    methods: {
        changeBright(n: number): void {
            //funkcja zmieniająca wartość jasności żarówki o + lub - 1
            (this as any).$emit("changeBright", n);
        },
        setBrightness(n: number): void {
            //tu powinno zostać wykonane żądanie z UPDATE do serwera z nową wartością jasności
            console.log(n);
        },
    },
};
